const apiContext = require.context('./modules', true, /\.js$/);

let apiObj = {};

apiContext.keys().forEach(item => {
    const apiConfig = apiContext(item);
    const api = apiConfig.default || apiConfig;
    apiObj = {
        ...apiObj,
        ...api
    };
});

const apiPlugin = {
    install: Vue => {
        Vue.prototype.$api = apiObj;
    }
};

export default apiPlugin;
